/*
 * Free Local Delivery progress bar — Kingdom Latin Foods
 *
 * The markup (and all values) are rendered server-side by Liquid inside Dawn's
 * re-rendered cart sections, so the bar is always correct after a cart change
 * without any fetch here. This element's only job is to animate the fill width
 * smoothly across those full-innerHTML re-renders, by starting from the last
 * known progress and transitioning to the new one.
 */
if (!customElements.get('free-delivery-bar')) {
  class FreeDeliveryBar extends HTMLElement {
    connectedCallback() {
      const fill = this.querySelector('.fld__fill');
      if (!fill) return;

      const target = parseFloat(this.dataset.progress) || 0;
      const previous = window.__fldLastProgress;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (reduceMotion || previous === undefined || previous === target) {
        // Nothing to animate: render at the final width immediately.
        fill.style.setProperty('--fld-progress', target + '%');
      } else {
        // Start from the previous value, force a reflow so the browser registers
        // it, then move to the target on the next frame to trigger the CSS transition.
        fill.style.setProperty('--fld-progress', previous + '%');
        void fill.offsetWidth;
        requestAnimationFrame(() => {
          fill.style.setProperty('--fld-progress', target + '%');
        });
      }

      window.__fldLastProgress = target;
    }
  }

  customElements.define('free-delivery-bar', FreeDeliveryBar);
}
